
import { Component, Vue, Emit, Watch } from "vue-property-decorator";
import { namespace, Getter, Mutation, Action } from "vuex-class";
import { DispatchRequest, DispatchType } from "@/store/mobile/types";

const Mobile = namespace("mobile");

@Component
export default class CloseProximity extends Vue {
	@Mobile.Getter("getActiveDispatchRequest")
	activeDispatchRequest: DispatchRequest;
	@Mobile.Action guardArrived: ({dispatchQueueId: number, hasArrived: boolean}) => Promise<void>;

	private expandCollapse: boolean = true;

	// Used due to inaccessable enum from template.
	private dispatchType: any = DispatchType;

	@Emit("arrived")
	public arrived(dispatchQueueID: number) {}

	private arrivedHandler() {
		this.guardArrived({dispatchQueueId: this.activeDispatchRequest.dispatchQueueID, hasArrived: true});
		this.arrived(this.activeDispatchRequest.dispatchQueueID);
	}

	private toggleMinimize() {
		this.expandCollapse = !this.expandCollapse;
	}
}
